export default {
  DEFAULT: {
    color: '',
    card: '',
    button: 'orange',
  },
  APPROVED: {
    color: 'font-green',
    card: 'approved',
    button: 'success',
  },
  REJECTED: {
    color: 'font-red',
    card: 'rejected',
    button: 'danger',
  },
};
